import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import classNames from "classnames";
import DocumentTitle from "react-document-title";
import OutsideClickHandler from "react-outside-click-handler";
import React, { Component } from "react";
import Div100vh from "react-div-100vh";
import "./WithNavigation.scss";
import { fetchAuthenticatedUser } from "../../store/actions/auth";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import Sidebar from "./Sidebar";
import Loader from "../../components/Loader";
import { updateWalkthroughChecklist } from "../../store/actions/easyWalkThroughForm";

import { setSideBar } from "../../store/actions/collapseSideBar";
import { selectCollapseSideBar } from "../../store/selectors/collapseSideBar";
import { Images } from "../../Tenants";

class WithNavigation extends Component {
  state = {
    sidebarIsVisible: false,
    collapsableSideBar: false,
  };

  componentDidMount() {
    const { onFetchAuthenticatedUser } = this.props;
    onFetchAuthenticatedUser();
  }

  collapsableSideBar() {
    const { onSetSideBar, collapsableSideBar } = this.props;
    this.setState({ collapsableSideBar: !collapsableSideBar });
    onSetSideBar(!collapsableSideBar);
  }

  render() {
    const { bottom, title, top, user, border, collapsableSideBar, hide, children, id, testId } =
      this.props;
    const { sidebarIsVisible } = this.state;
    const theme = localStorage.getItem("theme");
    const content = children ?? bottom;
    return user ? (
      <DocumentTitle
        title={theme === "Shape" ? `SHAPE | ${title} ` : `${title} | juniper`}
      >
        <>
          <Div100vh className="with-navigation">
            <OutsideClickHandler
              onOutsideClick={() => {
                this.setState({ sidebarIsVisible: false });
              }}
            >
              <div
                className={classNames("with-navigation__aside", {
                  "with-navigation__aside--visible": sidebarIsVisible,
                  "with-navigation__aside--collapseWidth": collapsableSideBar,
                })}
              >
                <Sidebar
                  user={this.props.user}
                  collapsableSideBar={() => this.collapsableSideBar()}
                  collapseSideBar={collapsableSideBar}
                  title={title}
                />
              </div>
            </OutsideClickHandler>
            <div
              className={classNames("with-navigation__blinds", {
                "with-navigation__blinds--visible": sidebarIsVisible,
              })}
            />
            <div
              className={classNames("with-navigation__body", {
                "with-navigation__body--collapseSideBar": collapsableSideBar,
              })}
            >
              <div className="with-navigation__hamburger-bar">
                <div className="with-navigation__hamburger">
                  <Button
                    onClick={() =>
                      this.setState({ sidebarIsVisible: !sidebarIsVisible })
                    }
                    weight="semantic"
                    icon={<Icon weight="light" glyph="bars" />}
                  />
                </div>
                <div className="with-navigation__logo">
                  <img
                    alt="juniper"
                    src={Images.logo}
                    style={{
                      height:
                        theme === "Formwerks"
                          ? "auto"
                          : theme === "Quadra" || theme === "Panatch"
                          ? "4rem"
                          : "2.5rem",
                    }}
                  />
                </div>
              </div>
              <div className="with-navigation__yield" data-cy={testId} id={id}>
                {top && (
                  <div
                    className="with-navigation__top"
                    style={{ borderBottomWidth: border ? 0 : null }}
                  >
                    {top}
                  </div>
                )}
                <div
                  className="with-navigation__bottom"
                  style={{ display: hide === true && "none" }}
                >
                  <div className="with-navigation__content">
                    {content}
                  </div>
                </div>
              </div>
            </div>
          </Div100vh>
        </>
      </DocumentTitle>
    ) : (
      <Loader />
    );
  }
}

const mapStateToProps = (state) => ({
  user: selectAuthenticatedUser(state),
  collapsableSideBar: selectCollapseSideBar(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchAuthenticatedUser: fetchAuthenticatedUser,
      onUpdateWalkthroughChecklist: updateWalkthroughChecklist,
      onSetSideBar: setSideBar,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(WithNavigation);
